import { useEffect } from "react";
import { track } from "../lib/track";

/**
 * Analytics readiness — GA4 + Google Search Console.
 * Activates ONLY when the owner provides real IDs via frontend env vars:
 *   REACT_APP_GA4_MEASUREMENT_ID  (or legacy REACT_APP_GA4_ID)  e.g. G-XXXXXXXXXX
 *   REACT_APP_GSC_VERIFICATION    Search Console meta verification token
 * Nothing is injected and no network calls are made while these are unset.
 * Also wires global phone_click / email_click events for every tel:/mailto: link.
 * Never send PII or financial details through track() params.
 */
export default function Analytics() {
  useEffect(() => {
    const ga4 = process.env.REACT_APP_GA4_MEASUREMENT_ID || process.env.REACT_APP_GA4_ID;
    if (ga4 && !document.getElementById("ga4-src")) {
      const s = document.createElement("script");
      s.id = "ga4-src";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", ga4);
    }
    const gsc = process.env.REACT_APP_GSC_VERIFICATION;
    if (gsc && !document.querySelector('meta[name="google-site-verification"]')) {
      const m = document.createElement("meta");
      m.name = "google-site-verification";
      m.content = gsc;
      document.head.appendChild(m);
    }
    // Global tap-to-call / email conversion events (no PII — just the action + page)
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href^='tel:'], a[href^='mailto:']");
      if (!a) return;
      track(a.href.startsWith("tel:") ? "phone_click" : "email_click", { page: window.location.pathname });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  return null;
}
